import React, {useState, useEffect, Suspense} from "react"
import ErrorBoundary, {LoadingErrorFallback} from "./error_boundary"
import {use_daltonize_image} from "components/hooks"
import {useImage} from "react-image"
import class_names from "classnames"

const LoadingImage = ({
  image_url,
  title,
  width,
  height,
  alt_text,
  style = {},
  spinner_delay_time = 0
}) => {
  if (width && height) {
    style.aspectRatio = `${width}/${height}`
    style.position = "relative"
  }
  return (
    <ErrorBoundary fallback={<LoadingErrorFallback style={style}/>}>
      <Suspense
        fallback={<Spinner style={style} delay_time={spinner_delay_time}/>}
      >
        <Image
          image_url={image_url} title={title} style={style} alt_text={alt_text}
        />
      </Suspense>
    </ErrorBoundary>
  )
}

const Image = ({image_url, title, style, alt_text}) => {
  let {src} = useImage({srcList: image_url})
  src = use_daltonize_image(src)
  const alt = alt_text || title
  return <img src={src} alt={alt} style={style}/>
}

// the visibility of the spinner is delayed so that it only is shown for long
// loading images and doesn't create a flicker for short loading images
const Spinner = ({style, delay_time}) => {
  const [is_visible, set_is_visible] = useState(!delay_time)
  useEffect(() => {
    const timer = setTimeout(() => set_is_visible(true), delay_time)
    return () => clearTimeout(timer)
  })
  return (
    <div
      className={class_names("spinner", {visibilty: !is_visible})}
      style={style}>
    </div>
  )
}

export default LoadingImage
